/**
 * @author Ahmed Samer
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2019-09-26
 * @description Implementation of the GraphQL mutation to add a tag.
 * @filename claim-profile.ts
 */
import { graphql, GraphQLTaggedNode } from "react-relay";

/**
 * The GraphQL mutation to add an podcast.
 *
 * @type {GraphQLTaggedNode}
 */
export const CLAIM_PROFILE_GRAPHQL_MUTATION: GraphQLTaggedNode = graphql`
  mutation claimProfileMutation($input: ClaimOwnershipInput!) {
    claimProfileOwnerShip(input: $input) {
      clientMutationId
      errors {
        id
        location
      }
      hasErrors
      person {
        id
        fullName
        landingPageUrl
      }
      entity {
        id
        name
        landingPageUrl
      }
    }
  }
`;
